<div id="faq" class="page-layout simple full-width">

    <!-- HEADER -->
    <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">
        <div class="hero-text mb-16">
            <h1>Creación Nueva Campaña
                <span> 
                    <mat-icon>add_circle</mat-icon>
                </span>
            </h1>
        </div>
    </div>
   
    <div class="flexContainer">
        <mat-card class="leadForm" style="width: 100%;">
            <mat-card-header>
                <mat-card-title-group>
                  <mat-card-title>FORMULARIO CAMPAÑA</mat-card-title>
                </mat-card-title-group>
            </mat-card-header>
            <mat-card-content class="flexContainer" style="flex-direction: column;">
              <div class="flexItem">
                <!--<mat-form-field appearance="outline" style="margin-right: 20px;">
                    <mat-label>Nombre</mat-label>
                    <input #name id="name" matInput>
                    <mat-icon matSuffix class="secondary-text">note_alt</mat-icon>
                </mat-form-field>
                  <mat-form-field appearance="outline" style="margin-right: 20px;">
                      <mat-label>CIF</mat-label>
                      <input #cif id="cif" matInput>
                      <mat-icon matSuffix class="secondary-text">business_center</mat-icon>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                      <mat-label>Email</mat-label>
                      <input #email id="email" matInput>
                      <mat-icon matSuffix class="secondary-text">email</mat-icon>
                  </mat-form-field>-->
              </div>
              <mat-label>Saludo inicial</mat-label>
              <div class="flexItem">
                  <textarea id="saludo"
                        rows="3"
                        style="width:90%; max-width: 90%; resize: none;">
                  </textarea>
              </div>
            <mat-label>Contexto Negocio</mat-label>
            <div class="flexItem">
                <textarea id="contexto"
                      rows="5"
                      style="width:90%; max-width: 90%; resize: none;">
                </textarea>
            </div>
            <mat-label>Indicadores a conocer</mat-label>
            <div class="flexItem">
                <textarea id="indicadores"
                    rows="5"
                    style="width:90%; max-width: 90%; resize: none;">
                </textarea>
            </div>
            <br>
            <br>
            <br>
            <br>
            <div class="atBottom">
                <button mat-raised-button (click)="enviarCamp()"  class="cta-button" style="margin-left: 10px;"  color="accent">
                  Actualizar campaña
                </button>
            </div>
            </mat-card-content>

        </mat-card>
    </div>
        
    <!-- ///////////////////////////////////////-->
        
</div>
<div *ngIf="loading" class="fuse-navy">
    <app-loading></app-loading>
</div>
